import { AdminSettingTypes as Type } from '../../../types/adminsetting';

const initialState = {
  updateAdmin: null,
  loading: false,
  error: null,
};

const UpdateAdminReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case Type.UPDATE_ADMIN_REQUEST:
      return { ...state, loading: true, error: null, updateAdmin: null };
    case Type.UPDATE_ADMIN_REQUEST_SUCCESS:
      return {
        ...state,
        updateAdmin: action.payload,
        loading: false,
      };
    case Type.UPDATE_ADMIN_REQUEST_FAILURE:
      return { ...state, error: action.error, loading: false };
      case Type.RESET_UPDATE_ADMIN_STATE:
        return { ...initialState };
    default:
      return state;
  }
};

export default UpdateAdminReducer;